import type { SelectOption } from "@/components/basics/Select.vue";
import type { Parameter, Value } from "@/services/collection/parameters/parametersTypes";

const createSelectOptions = (parameter: Parameter): SelectOption[] =>
  parameter.values //
    .filter((value: Value) => !value.isCustom) //
    .map((value: Value) => ({ label: value.value, value: value.id }));

export const Helpers = {
  createSelectOptions,
};
